import { Heading } from "@mittwald/flow-remote-react-components";
import { Section } from "@mittwald/flow-remote-react-components";
import { useRouteError } from "react-router";
import { LayoutCard } from "@mittwald/flow-remote-react-components";
import {
  DefaultErrorComponent,
  ErrorDeveloperDetails,
  ErrorMap,
} from "@wiesinghilker/extension-lib-frontend";

export const ErrorElement = (props: { errorMap: ErrorMap }) => {
  const error = useRouteError();

  if (!(error instanceof Error)) {
    throw new Error("error is no Error");
  }

  const ErrorComponent =
    props.errorMap[error.constructor.name] ?? (() => <DefaultErrorComponent />);

  return (
    <>
      <LayoutCard>
        <Section>
          <Heading level={1}>Ein Fehler ist aufgetreten</Heading>

          <>{ErrorComponent(error)}</>

          <ErrorDeveloperDetails />
        </Section>
      </LayoutCard>
    </>
  );
};
